import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SentryDocsLayout from '../docs/SentryDocsLayout';
import SentryDocsRouter from '../docs/SentryDocsRouter';
import DocsLayout from '../docs/DocsLayout';
import DocsRouter from '../docs/DocsRouter';

/**
 * Component that renders the appropriate docs based on domain
 */
const SentryDocsRoute: React.FC = () => {
  const location = useLocation();
  
  // Check if we're on the Sentry domain
  const isSentryDomain = 
    typeof window !== 'undefined' && 
    (window.location.hostname === 'sentry.trading' || 
     window.location.hostname === 'www.sentry.trading');

  const gitbookDocsUrl = 'https://mavrk.gitbook.io/sentry-docs/';

  // Redirect sentry.trading/docs to GitBook
  useEffect(() => {
    if (isSentryDomain) {
      window.location.replace(gitbookDocsUrl);
    }
  }, [isSentryDomain]);

  if (isSentryDomain) {
    return null;
  }

  // On other domains, check if path is /sentry/docs
  if (location.pathname.startsWith('/sentry/docs')) {
    return (
      <SentryDocsLayout>
        <SentryDocsRouter />
      </SentryDocsLayout>
    );
  }

  // Otherwise show main docs
  return (
    <DocsLayout>
      <DocsRouter />
    </DocsLayout>
  );
};

export default SentryDocsRoute;
